/**
 * Created by Nisarg on 9/4/2017.
 */
import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, NavLink, TabContent} from 'reactstrap';
import {TabPane, Nav, NavItem} from 'reactstrap';
import classnames from 'classnames';
import firebase from 'firebase';
import $ from 'jquery';
import _HauteFire from '../Utils/HauteFire';
import {Accordion, AccordionItem} from 'react-sanfona';

const HauteFire = new _HauteFire();
const CLIENTID = '473861865114-reblkdvrsa2b9etplbfe2hmfvdmkp3ue.apps.googleusercontent.com';
const APIKEY = 'AIzaSyBCNIlfobAJwMId0FaUjCjU4TuZAbJzhm0';
const SCOPES = 'https://www.googleapis.com/auth/gmail.readonly';

export default class EnquiryDetails extends Component {
    constructor() {
        super();

        this.state = {
            authUId: "",
            authEmail: "",
            AllEnquiries: [],
            activeTab: '1',
            activeEnquiry: {},
            isGoogleAuthorized: false,
            recipientMailMessages: [],
            sampleDemoStr: ""
        }
    }

    componentDidMount() {
        const _this = this;

        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                _this.setState({authUId: user.uid, authEmail: user.email});
            } else {
                console.error("Not logged in");
            }
        });

        let enquiryRef = firebase.database().ref('EnquiryDetails');
        enquiryRef.on('value', (response) => {
            let AllEnquiries = response.val();
            if (AllEnquiries != null) {
                const keys = Object.keys(AllEnquiries);
                AllEnquiries = keys.map((key) => {
                    return AllEnquiries[key]
                });
                if (AllEnquiries.length > 0) {
                    AllEnquiries = AllEnquiries.reverse();
                    _this.setState({AllEnquiries});
                }
            }
        });

        this.initGoogleAuth();

        $(document).on("keyup", ".taEnqComment", this.addEnquiryComment.bind(this));
    }

    initGoogleAuth() {
        const _this = this;

        require("google-client-api")().then((gapi) => {
            gapi.client.setApiKey(APIKEY);
            window.setTimeout(checkAuth, 1);

            function checkAuth() {
                gapi.auth.authorize({
                    client_id: CLIENTID,
                    scope: SCOPES,
                    immediate: true
                }, (authResult) => {
                    if (authResult && !authResult.error) {
                        _this.setState({isGoogleAuthorized: true});
                    }
                    else {
                        _this.setState({isGoogleAuthorized: false});
                    }
                });
            }
        });
    }

    addEnquiryComment(e) {
        if (e.keyCode == 13) {
            const enquiryId = e.currentTarget.attributes["data-enqId"].value;
            const comment = e.currentTarget.value.trim();
            if (comment != "" && enquiryId != undefined) {
                let commentObj = {
                    id: Date.now(),
                    comment,
                    commentedOn: new Date().toString(),
                    commentedBy: this.state.authEmail,
                    authUId: this.state.authUId
                }
                let enquiry = this.state.AllEnquiries.filter((enq) => {
                    return enq.id == enquiryId
                })[0];
                if (enquiry != undefined) {
                    let _div = $(e.currentTarget).parent("div").parent("div");
                    _div.animate({left: 250}, 2500, () => {
                        _div.remove();

                        enquiry.Comments = enquiry.Comments || [];
                        enquiry.Comments.push(commentObj);

                        HauteFire.addUpdate(enquiry.id, enquiry, "EnquiryDetails");
                    });
                }
            }
        }
    }

    addComment(e) {
        const modalEnquiryId = e.currentTarget.attributes["data-enqId"].value;
        const enquiry = this.state.AllEnquiries.filter((enq) => {
            return enq.id == modalEnquiryId
        })[0];

        if ($(`div#divEnq${modalEnquiryId}`).next().has(":input").length == 0) {
            $(`div#divEnq${modalEnquiryId}`).after("<div class='col-sm-6 col-md-12' style='left:-500px'> <div class='card'> <textarea autofocus='autofocus' rows='4' class='taEnqComment form-control' data-enqId=" + modalEnquiryId + " placeholder='Add comment ...' /> </div></div>");
            $(`div#divEnq${modalEnquiryId}`).next().animate({left: 0}, 2500);
        }
    }

    renderEnquiryComments(comment) {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const _date = new Date(comment.commentedOn);
        const commentedDate = _date.getDate() + "-" + months[_date.getMonth()] + "-" + _date.getFullYear() + "  " + _date.getHours() + ":" + _date.getMinutes();

        return (<div className="col-sm-6 col-md-12" key={comment.id}>
            <div className="card card-inverse card-primary">
                <div className="card-block">
                    {comment.comment}
                </div>
                <div className="card-header">Commented by {comment.commentedBy} on <i
                    className="fa fa-clock-o"></i> {commentedDate}</div>
            </div>
        </div>)
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    collapsibleOpen(e) {
        const enquiry = this.state.AllEnquiries[e];
        if (enquiry != (undefined || null)) {
            if (enquiry.Recipient.hasOwnProperty('messageId') && !enquiry.Recipient.hasOwnProperty('threadId')) {
                const messageId = enquiry.Recipient.messageId;
                this.getReceipientSentMail(messageId, enquiry.id);
            }
            else {
                this.getReceipientMailMessages(enquiry.Recipient.threadId);
            }
            this.setState({activeEnquiry: enquiry});
        }
    }

    getReceipientSentMail(messageId, enquiryId) {
        const _this = this;

        require("google-client-api")().then((gapi) => {
            gapi.client.setApiKey(APIKEY);
            window.setTimeout(checkAuth, 1);

            function checkAuth() {
                gapi.auth.authorize({
                    client_id: CLIENTID,
                    scope: SCOPES,
                    immediate: true
                }, (authResult) => {
                    if (authResult && !authResult.error) {
                        gapi.client.load('gmail', 'v1', getSentItems);
                    }
                });
            }

            function getSentItems() {
                require('google-client-api')().then((gapi) => {
                    let requestSent = gapi.client.gmail.users.messages.list({
                        'userId': 'me',
                        'labelIds': 'SENT'
                    });

                    requestSent.execute(function (response) {
                        $(response.messages).each((index, message) => {
                            const requestMessage = gapi.client.gmail.users.messages.get({
                                'userId': 'me',
                                'id': message.id
                            });

                            requestMessage.execute(getMessage);
                        });
                    });

                    function getMessage(response) {
                        const MessageID = response.payload.headers.find((header) => {
                            return header.name == "Message-ID"
                        }).value;
                        if (MessageID != (undefined || null)) {
                            if (MessageID == messageId) {
                                const threadId = response.threadId;
                                debugger;
                                let AllEnquiries = _this.state.AllEnquiries;
                                let enquiry = AllEnquiries.find((obj) => {
                                    return obj.id == enquiryId
                                });
                                if (enquiry != (undefined || null)) {
                                    let Recipient = enquiry.Recipient;
                                    Recipient.threadId = threadId;

                                    HauteFire.addUpdate(enquiryId, enquiry, "EnquiryDetails");
                                    _this.setState({AllEnquiries});

                                    _this.getReceipientMailMessages(threadId);  //get mail messages from threadId
                                }
                            }
                        }
                    }
                })
            }
        });
    }

    getReceipientMailMessages(threadId) {
        const _this = this;

        require("google-client-api")().then((gapi) => {
            gapi.client.setApiKey(APIKEY);
            window.setTimeout(checkAuth, 1);

            function checkAuth() {
                gapi.auth.authorize({
                    client_id: CLIENTID,
                    scope: SCOPES,
                    immediate: true
                }, (authResult) => {
                    if (authResult && !authResult.error) {
                        gapi.client.load('gmail', 'v1', getSentMessages);
                    }
                });
            }

            function getSentMessages() {
                let requestThread = gapi.client.gmail.users.threads.get({
                    'userId': 'me',
                    'id': threadId
                });

                requestThread.execute((response) => {
                    let encodedBody = response.messages[0].payload.body.data.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
                    encodedBody = decodeURIComponent(window.escape(window.atob(encodedBody)));
                    debugger;
                    _this.setState({sampleDemoStr: encodedBody});
                })
            }
        });
    }

    renderEnquiries(enquiry) {
        const recipient = enquiry.Recipient;
        const inquiry = recipient.enquiry;
        const recipientName = recipient.name;
        const recipientContactNumber = recipient.contactNumber;
        const recipientEmail = recipient.email;
        const _enquiry = enquiry.Enquiry;
        const adults = _enquiry.adults;
        const children = _enquiry.children;
        const rooms = _enquiry.rooms;
        const islandName = enquiry.Island.islandName;
        const enquiryId = enquiry.id;
        const islandId = enquiry.Island.islandId;
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const _fromDate = new Date(_enquiry.fromDate);
        const enqFromDate = _fromDate.getDate() + "-" + months[_fromDate.getMonth()] + "-" + _fromDate.getFullYear();
        const _toDate = new Date(_enquiry.toDate);
        const enqToDate = _toDate.getDate() + "-" + months[_toDate.getMonth()] + "-" + _toDate.getFullYear();
        let comments = enquiry.Enquiry.Comments;
        if (comments != undefined) {
            comments = comments.reverse();
        }

        return (<AccordionItem title={recipientName + " #" + islandName} key={enquiry.id} data-enquiryId={enquiry.id}
                               onExpand={this.collapsibleOpen.bind(this)}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <table className="table table-bordered">
                                <tbody>
                                <tr>
                                    <th scope="row">Name</th>
                                    <td>{recipientName}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Contact No</th>
                                    <td>
                                        <a href={'tel:' + recipientContactNumber}>{recipientContactNumber}</a>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Email</th>
                                    <td>
                                        <a href={'mailto:' + recipientEmail}>{recipientEmail}</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-6">
                            <table className="table table-bordered">
                                <tbody>
                                <tr>
                                    <th scope="row">Island Name</th>
                                    <td>{islandName}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Rooms</th>
                                    <td>{rooms}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Adults</th>
                                    <td>{adults}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Children</th>
                                    <td colSpan="2">{children}</td>
                                </tr>
                                <tr>
                                    <th scope="row">From date</th>
                                    <td colSpan="2">{_fromDate.toDateString()}</td>
                                </tr>
                                <tr>
                                    <th scope="row">To date</th>
                                    <td colSpan="2">{_toDate.toDateString()}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row">
                        <div id={"divEnq" + enquiryId} className="col-sm-6 col-md-12">
                            <div className="card card-accent-primary">
                                <div className="card-header">
                                    Enquiry&nbsp;<i title="From date" className="fa fa-clock-o"
                                                    aria-hidden="true"></i>&nbsp;{enqFromDate} &nbsp;
                                    to &nbsp; {enqToDate}
                                    <label className="switch switch-sm switch-text switch-info float-right mb-0"
                                           style={{width: 120}}>
                                        <a title="Add comment" data-enqId={enquiryId}
                                           onClick={this.addComment.bind(this)}><i
                                            className="fa fa-commenting-o fa-lg"
                                            aria-hidden="true"></i> Add comment
                                        </a>
                                    </label>
                                </div>
                                <div className="card-block">
                                    {inquiry}
                                </div>
                            </div>
                        </div>

                        {comments != undefined ? comments.map((comment) => {
                            return this.renderEnquiryComments(comment)
                        }) : ""}

                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <Nav tabs className="nav-justified">
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === '1'})}
                                        onClick={() => {
                                            this.toggle('1');
                                        }}
                                    >
                                        <i className="fa fa-user" aria-hidden="true"></i> Customer &nbsp;&nbsp;
                                        #<b>{recipientName}</b>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === '2'})}
                                        onClick={() => {
                                            this.toggle('2');
                                        }}
                                    >
                                        <i className="fa fa-h-square" aria-hidden="true"></i> Island Owner &nbsp;&nbsp;
                                        #<b>{islandName}</b>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="1">

                                    <div className="row">
                                        <div className="col-md-12 mb-4">
                                            <div className="card card-accent-danger">
                                                <div className="card-header">
                                                    Card with accent
                                                </div>
                                                <div className="card-block">
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: this.state.sampleDemoStr}}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </TabPane>
                                <TabPane tabId="2">

                                    ISLAND OWNER INFO

                                </TabPane>
                            </TabContent>
                        </div>
                    </div>

                </div>
            </AccordionItem>
        )
    }

    render() {
        return (<div>

                <Accordion>
                    {this.state.AllEnquiries.length > 0 ?
                        this.state.AllEnquiries.map((enquiry) => {
                            return this.renderEnquiries(enquiry)
                        })
                        : ""}
                </Accordion>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/EnquiryDetails/EnquiryDetails.js